<template>
  <div class="list-accordion-item">
    <div class="list-accordion-header">
      <div>
        <div class="list-accordion-header-map" v-if="false">
          <button type="button" class="map-show btn btn-small btn-dark" @click="showMap">
            <IconMap />
            View Map
          </button>
        </div>
        <button type="button" class="list-accordion-header-mag" @click="setZoomToLocation(location)">
          <IconZoom />
        </button>
        <h2 class="list-accordion-header-title" @click="togglePanel($event)">{{ location.name }}</h2>
      </div>
      <div @click="togglePanel($event)">
        <div v-if="false" class="list-accordion-header-num">{{ communities.length }} neighborhoods</div>
        <button type="button" class="list-accordion-toggle" @click="togglePanel($event)">
          <IconTriangleDown :style="{ transform: showPanel ? 'rotate(180deg)' : 'rotate(0deg)' }" />
        </button>
      </div>
    </div>

    <transition
      name="accordion-item"
      appear
      @enter="startTransition"
      @after-enter="endTransition"
      @before-leave="startTransition"
      @after-leave="endTransition"
    >
      <div class="list-accordion-panel" v-show="showPanel">
        <div class="list-grid">
          <div
            class="list-grid-box"
            @click="showDetail(community, $event)"
            v-for="community in communities"
            :key="`${community.id}-${community.slug}`"
          >
            <div class="list-grid-box-image slick-loading">
              <div :class="{ 'list-slider': community.slide_images.length > 1 }" :id="`list-slider-${community.id}`">
                <div
                  class="list-slider-slide"
                  v-for="(slide, i) in community.slide_images"
                  :key="`list-slider-slide-${i}`"
                >
                  <img :src="slide.url" :alt="slide.title" width="400" height="250" />
                </div>
              </div>
              <div class="list-grid-box-image-badge align-right">{{ community.availability }}</div>
              <div class="list-detail-slider-controls" v-if="community.slide_images.length > 1">
                <button type="button" class="arrow-prev" :id="`arrow-prev-${community.id}`">
                  <IconTriangleLeft />
                </button>
                <button type="button" class="arrow-next" :id="`arrow-next-${community.id}`">
                  <IconTriangleRight />
                </button>
              </div>
            </div>
            <div class="list-grid-box-title">{{ community.title }}</div>
            <div class="list-grid-box-cost">{{ startingAt(community.price) }}</div>
            <div class="list-grid-box-location">Location: {{ community.location }}</div>
            <div class="list-grid-box-school">School District: {{ community.school_district }}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import IconMap from '@/components/icons/IconMap';
import IconTriangleDown from '@/components/icons/IconTriangleDown';
import IconTriangleRight from '@/components/icons/IconTriangleRight';
import IconTriangleLeft from '@/components/icons/IconTriangleLeft';
import IconZoom from '@/components/icons/IconZoom';
import { uuidv4 } from '@/helpers/ui';

export default {
  name: 'CommunityListAccordionItem',
  components: {
    IconMap,
    IconTriangleDown,
    IconTriangleRight,
    IconTriangleLeft,
    IconZoom,
  },
  props: {
    location: {
      type: Object,
      required: true,
    },
    communities: {
      type: Array,
      required: true,
    },
  },
  // mounted() {
  //   console.log('CommunityListAccordionItem mounted()', this.location, this.communities);
  // },
  computed: {
    isMapDisplayed() {
      return this.$store.getters['ui/isMapDisplayed'];
    },
    uuid() {
      return 'id-' + uuidv4();
    },
  },
  data() {
    return {
      showPanel: false,
    };
  },
  methods: {
    togglePanel(event) {
      event.preventDefault();
      event.stopPropagation();
      this.showPanel = !this.showPanel;

      // if (this.showPanel) {
      //   this.$emit('initSlider');
      // }
    },
    startTransition(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    endTransition(el) {
      el.style.height = '';

      if (this.showPanel) {
        this.$emit('openPanel');
      }
    },
    setZoomToLocation(location) {
      // console.log('CommunityListAccordionItem setZoomToLocation()', location);
      if (window.innerWidth < 768 && !this.isMapDisplayed) {
        this.$store.dispatch('ui/setMapDisplay', { mapDisplay: true });
      }
      this.$store.dispatch('ui/setZoomToLocation', { location });
    },
    showDetail(community, event) {
      if (this.isMapDisplayed) {
        this.$store.dispatch('ui/setPanelView', { community, panelView: 'detail' });
      } else {
        if (event.target.className !== 'slick-slider-button') {
          window.location = community.link;
        }
      }
    },
    showMap() {
      // console.log('CommunityListAccordionItem showMap()');
      this.$store.dispatch('ui/setMapDisplay', { mapDisplay: true });
    },
    startingAt(price) {
      const thePrice = Number(price.replaceAll(',', ''));
      if (thePrice > 0) {
        const formattedAmount = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 0  // Ensures at most two decimal places
        }).format(thePrice);

        return formattedAmount;
      } else {
        return 'Contact Us';
      }
    },
  },
};
</script>
